<template>
  <div class="date-wrapper">
    <div v-if="label" class="label">{{ label }}</div>
    <div class="data-model">
      <div v-if="coins" class="coins">{{ coins }}</div>

      <ModelSelect
        class="month"
        label="Месяц"
        :items="months"
        v-model="month"
        :disabled="disabled"
      />
      <ModelString
        class="year"
        type="number"
        label="Год"
        v-model="year"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import ModelSelect from "./ModelSelect";
import ModelString from "./ModelString";

export default {
    name: "ModelYM",
    props: {
        ym: Number,
        coins: Number,
        disabled: Boolean,
        label: String,
    },
    components: {
        ModelSelect,
        ModelString,
    },
    data() {
        const month = this.ym % 100;
        const year = (this.ym - month) / 100;

        return {
            month,
            year: year ? year : null,
            months: [
                { text: "Январь", value: 1 },
                { text: "Февраль", value: 2 },
                { text: "Март", value: 3 },
                { text: "Апрель", value: 4 },
                { text: "Май", value: 5 },
                { text: "Июнь", value: 6 },
                { text: "Июль", value: 7 },
                { text: "Август", value: 8 },
                { text: "Сентябрь", value: 9 },
                { text: "Октябрь", value: 10 },
                { text: "Ноябрь", value: 11 },
                { text: "Декабрь", value: 12 },
            ],
        };
    },
    computed: {},
    model: {
        prop: "ym",
        event: "change",
    },
    methods: {
        emit() {
            if (this.year < 1900 || this.year > 2030) return;

            const ym =
        String(this.year) + (this.month < 10 ? "0" : "") + String(this.month);

            this.$emit("change", +ym);
        },
    },
    watch: {
        ym(val) {
            this.month = val % 100;
            this.year = (val - this.month) / 100;
        },
        month() {
            this.emit();
        },
        year() {
            this.emit();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/rem";
@import "../../../styles/mrem";

.date-wrapper {
  margin-top: rem(20);
}

.data-model {
  display: flex;
  border: none;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}

.label {
  margin-bottom: rem(8);
  font-family: "Open Sans", sans-serif;
  font-size: rem(16);
  line-height: rem(20);
  font-weight: 500;
  position: static;
  width: 100%;
}

.month {
  flex: 3 1 auto;
  border-radius: rem(10)!important;
}

.year {
  margin-left: -1px;
  flex: 1 1 auto;
  width: auto;
}

@import "../../../styles/variables";
@media (max-width: $vm) {
  .data-model {
  }

  .month {
    border-radius: mrem(4) 0 0 mrem(4);
  }

  .year {
    border-radius: 0 mrem(10) mrem(10) 0;
  }

  .label {
    margin-bottom: mrem(8);
    font-size: mrem(16);
    line-height: mrem(22);
    font-weight: normal;
  }
}
</style>
